// 导入所有 property 模块的国际化文件
import { messages as downloadTempFileMessages } from '@/lang/property/downloadTempFileLang.js'

// 合并所有国际化消息
export const messages = {
    en: {
        ...downloadTempFileMessages.en
    },
    zh: {
        ...downloadTempFileMessages.zh
    }
} 